import styled, { css } from 'styled-components';

/**
 * Figma PERFORMANCE-HUB `no-leads-profile-incomplete` banner CTAs (20648:8675).
 * Colors are theme.semantic only — values from HYROX `get_variable_defs`:
 *
 * Check your profile (20648:8676):
 *   border → semantic colors/neutrals/700
 *   label  → texts-small-elements
 *
 * Update your profile (20648:8677):
 *   fill   → semantic colors/accent/500
 *   label  → content-primary-button
 */
const pillButtonBase = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-height: ${({ theme: { spacing } }) => spacing(10)};
  padding: ${({ theme: { spacing } }) => `${spacing(2)} ${spacing(2)}`};
  border-radius: ${({ theme: { spacing } }) => spacing(5)};
  font-family: ${({ theme: { typography } }) => typography.poppins};
  font-size: 1rem;
  font-weight: ${({ theme: { typography } }) => typography.bold};
  line-height: normal;
  white-space: nowrap;
  cursor: pointer;

  &[aria-disabled='true'] {
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: ${({ theme: { spacing } }) => spacing(0.5)} solid ${({ theme }) => theme.semantic.accent_500};
    outline-offset: ${({ theme: { spacing } }) => spacing(0.5)};
  }
`;

export const LeadsOutlineButton = styled.button`
  ${pillButtonBase}
  border: 0.0625rem solid ${({ theme }) => theme.semantic.neutrals_700};
  background: transparent;
  color: ${({ theme }) => theme.semantic.text_small_elements};
`;

export const LeadsAccentButton = styled.button`
  ${pillButtonBase}
  border: none;
  background: ${({ theme }) => theme.semantic.accent_500};
  color: ${({ theme }) => theme.semantic.content_primary_button};
`;
